import React from 'react';
import { FormattedMessage } from 'react-intl';

export const AllThings = (thingPlural) => (
  <FormattedMessage
    id="filterbar - All Things"
    defaultMessage="All {thingPlural}"
    values={{ thingPlural }}
  />
);

export const AllThingsCount = (thingPlural, thingCount) => (
  <FormattedMessage
    id="filterbar - All Things Count"
    defaultMessage="All {thingPlural} ({thingCount})"
    values={{ thingPlural, thingCount }}
  />
);

export const More = (
  <FormattedMessage
    id="filterbar - More"
    defaultMessage="More"
  />
);

export const FilterBy = (thingPlural) => (
  <FormattedMessage
    id="filterbar - Filter {thingPlural} by:"
    defaultMessage="Filter {thingPlural} by:"
    values={{ thingPlural }}
  />
);

export const ViewAllFilters = (thing) => (
  <FormattedMessage
    id="filterbar - View all {thing} filters"
    defaultMessage="View all {thing} filters"
    values={{ thing }}
  />
);
